import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=43641ac2"
import script from "./ViewResult.vue?vue&type=script&lang=js"
export * from "./ViewResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43641ac2')) {
      api.createRecord('43641ac2', component.options)
    } else {
      api.reload('43641ac2', component.options)
    }
    module.hot.accept("./ViewResult.vue?vue&type=template&id=43641ac2", function () {
      api.rerender('43641ac2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/dynamic_division/ViewResult.vue"
export default component.exports